(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* header shadow + mobile menu */
  const header = $('[data-header]');
  const onScroll = () => header && header.classList.toggle('is-scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  const nav = $('[data-mobile-nav]');
  $$('[data-menu-open]').forEach(b => b.addEventListener('click', () => { nav.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }));
  $$('[data-menu-close]').forEach(b => b.addEventListener('click', () => { nav.classList.remove('is-open'); $$('[data-menu-open]').forEach(x => x.setAttribute('aria-expanded', 'false')); document.body.style.overflow = ''; }));

  /* reveal on scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(el => io.observe(el));
  } else { $$('.reveal').forEach(el => el.classList.add('is-in')); }

  /* cart drawer */
  const drawerSel = '[data-drawer]';
  const openDrawer = () => { const d = $(drawerSel); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; const c = $('[data-drawer-close].icon-btn', d); c && c.focus(); };
  const closeDrawer = () => { const d = $(drawerSel); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
  const refreshCart = async (open) => {
    const res = await fetch(`${window.ELION.root}?sections=cart-drawer`.replace('//?', '/?'));
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $(drawerSel, html);
    const old = $(drawerSel);
    if (fresh && old) { old.innerHTML = fresh.innerHTML; }
    const cart = await fetch(`${window.ELION.cartUrl}.js`).then(r => r.json());
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    if (open) openDrawer();
  };
  document.addEventListener('click', async e => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && $(drawerSel) && !document.body.classList.contains('tpl-cart')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    const q = e.target.closest('[data-qty]');
    if (q) {
      q.disabled = true;
      await fetch(`${window.ELION.cartChangeUrl}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: q.dataset.key, quantity: Number(q.dataset.qty) }) });
      if (document.body.classList.contains('tpl-cart')) { location.reload(); } else { await refreshCart(false); }
    }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); $$('[data-modal].is-open').forEach(m => closeModal(m)); } });

  /* product */
  $$('[data-product]').forEach(root => {
    const variants = JSON.parse($('[data-variants]', root).textContent);
    const colorMedia = (() => { try { return JSON.parse(($('[data-color-media]', root) || {}).textContent || '{}'); } catch (e) { return {}; } })();
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add]', root);
    const addLabel = $('[data-add-label]', root);
    const errorEl = $('[data-error]', root);
    const gallery = $('[data-gallery]', root);
    const dots = $('[data-dots]', root);
    const slides = $$('.pdp__slide:not([data-variant-slide])', gallery);

    // dots (mobile carousel)
    if (dots && slides.length > 1) {
      dots.innerHTML = slides.map((_, i) => `<span${i === 0 ? ' class="is-active"' : ''}></span>`).join('');
      gallery.addEventListener('scroll', () => {
        const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        $$('span', dots).forEach((d, j) => d.classList.toggle('is-active', i === j));
      }, { passive: true });
    }

    const current = () => $$('[data-option]', root).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
    const update = () => {
      const sel = current();
      const v = variants.find(x => x.options.every((o, i) => o === sel[i]));
      $$('[data-option]', root).forEach((fs, i) => { const out = $('[data-option-value]', fs); if (out) out.textContent = sel[i]; });
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Non disponibile'; return; }
      idInput.value = v.id;
      $$('[data-price]', root).forEach(p => p.textContent = v.price);
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito';
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      if (!v.media) { const c = sel.map(x => String(x || '').toLowerCase()).find(x => colorMedia[x]); if (c) v.media = colorMedia[c]; }
      $$('[data-variant-slide]', gallery).forEach(s => { s.hidden = String(s.dataset.mediaId) !== String(v.media); if (s.hidden) gallery.appendChild(s); });
      if (v.media) {
        const slide = $(`[data-media-id="${v.media}"]`, gallery);
        if (slide) {
          if (slide.hasAttribute('data-variant-slide') && slide !== gallery.firstElementChild) gallery.insertBefore(slide, gallery.firstElementChild);
          if (window.matchMedia('(max-width: 900px)').matches) { gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }); }
          else if (slide !== gallery.firstElementChild) { gallery.insertBefore(slide, gallery.firstElementChild); }
        }
      }
    };
    $$('[data-option] input', root).forEach(i => i.addEventListener('change', update));

    const add = async () => {
      errorEl.hidden = true;
      addBtn.disabled = true; const prev = addLabel.textContent; addLabel.textContent = 'Aggiungo…';
      try {
        const res = await fetch(`${window.ELION.cartAddUrl}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }) });
        if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.description || 'Impossibile aggiungere al carrello.'); }
        await refreshCart(true);
      } catch (err) { errorEl.textContent = err.message; errorEl.hidden = false; }
      addBtn.disabled = false; addLabel.textContent = prev;
    };
    form.addEventListener('submit', e => { e.preventDefault(); add(); });

    // sticky buy bar (mobile)
    const bar = $('[data-sticky-buy]', root);
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { const show = !en.isIntersecting && en.boundingClientRect.top < 0; bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', String(!show)); }).observe(addBtn);
      $('[data-sticky-add]', bar).addEventListener('click', () => { if (current().some(x => x === null)) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); } else { add(); } });
    }
  });

  /* modals */
  const openModal = m => { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
  const closeModal = m => { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
  $$('[data-modal-open]').forEach(b => b.addEventListener('click', () => { const m = document.getElementById(b.dataset.modalOpen); m && openModal(m); }));
  $$('[data-modal]').forEach(m => $$('[data-modal-close]', m).forEach(c => c.addEventListener('click', () => closeModal(m))));

  /* ring sizer — sizes US 8–13; between sizes → larger */
  const sizer = $('[data-sizer]');
  if (sizer) {
    const SIZES = [{ s: '8', d: 18.2, c: 57.2 }, { s: '9', d: 19.0, c: 59.7 }, { s: '10', d: 19.8, c: 62.2 }, { s: '11', d: 20.6, c: 64.7 }, { s: '12', d: 21.4, c: 67.2 }, { s: '13', d: 22.2, c: 69.7 }];
    const CARD_W = 53.98, CARD_H = 85.6;
    const fmt = n => n.toFixed(1).replace('.', ',');
    const result = $('[data-result]', sizer);
    let pxPerMm = 210 / CARD_W;
    const pick = (val, key, tol) => {
      const min = SIZES[0][key] - tol, max = SIZES[SIZES.length - 1][key] + tol;
      if (!(val > 0)) return { msg: 'Inserisci un valore valido in millimetri.' };
      if (val < min || val > max) return { msg: `La misura è fuori dall’intervallo disponibile (${fmt(SIZES[0][key])}–${fmt(SIZES[SIZES.length - 1][key])} mm). Scrivici prima di ordinare.` };
      const hit = SIZES.find(x => x[key] >= val - tol) || SIZES[SIZES.length - 1];
      return { hit };
    };
    const show = r => {
      result.hidden = false;
      if (r.msg) { result.textContent = r.msg; return; }
      const h = r.hit;
      result.innerHTML = `Taglia consigliata: <b>US ${h.s}</b> · diametro ${fmt(h.d)} mm · circonferenza ${fmt(h.c)} mm`;
      // preselect the size on the page
      const radio = $$('[data-option] input').find(i => i.value === h.s);
      if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
    };
    // tabs
    $$('[data-tab]', sizer).forEach(t => t.addEventListener('click', () => {
      $$('[data-tab]', sizer).forEach(x => x.setAttribute('aria-selected', String(x === t)));
      $$('[data-panel]', sizer).forEach(p => p.hidden = p.dataset.panel !== t.dataset.tab);
      result.hidden = true;
    }));
    // calibration
    const card = $('[data-card]', sizer), cardRange = $('[data-card-range]', sizer);
    const drawCard = () => { const w = Number(cardRange.value); card.style.width = w + 'px'; card.style.height = Math.round(w * CARD_H / CARD_W) + 'px'; };
    cardRange.addEventListener('input', drawCard); drawCard();
    const ring = $('[data-ring]', sizer), ringRange = $('[data-ring-range]', sizer), ringOut = $('[data-ring-out]', sizer);
    const drawRing = () => { const d = Number(ringRange.value); const px = d * pxPerMm; ring.style.width = ring.style.height = px + 'px'; ringOut.textContent = fmt(d) + ' mm'; };
    ringRange.addEventListener('input', drawRing);
    const step = n => $$('[data-step]', sizer).forEach(s => s.hidden = s.dataset.step !== String(n));
    $('[data-calibrate]', sizer).addEventListener('click', () => { pxPerMm = Number(cardRange.value) / CARD_W; step(2); drawRing(); result.hidden = true; });
    $('[data-recalibrate]', sizer).addEventListener('click', () => { step(1); result.hidden = true; });
    $('[data-find]', sizer).addEventListener('click', () => show(pick(Number(ringRange.value), 'd', 0.1)));
    $('[data-mm-find]', sizer).addEventListener('click', () => {
      const v = parseFloat(String($('[data-mm-value]', sizer).value).replace(',', '.'));
      const type = $('[data-mm-type]', sizer).value;
      show(pick(v, type === 'c' ? 'c' : 'd', type === 'c' ? 0.3 : 0.1));
    });
  }
})();
